import { render, staticRenderFns } from "./LuckResLayer.vue?vue&type=template&id=d1491d8c&scoped=true&"
import script from "./LuckResLayer.vue?vue&type=script&lang=js&"
export * from "./LuckResLayer.vue?vue&type=script&lang=js&"
import style0 from "./LuckResLayer.vue?vue&type=style&index=0&id=d1491d8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1491d8c",
  null
  
)

export default component.exports